import React from 'react';

/*
  What OnHand says about a page that is not built.

  **Built 10 September 2026 for job 25, from Group H's approved drawing.** The
  owner's answer to the question was one word, "yes": one shape and one word.

  **Photographing it first made the answer bigger than the question.** There
  were not two looks, there were two looks and THREE words, and two of the three
  were visible in the same picture, disagreeing with each other:

    the menu tab said           Soon
    the page that tab opened    COMING SOON
    three Site Settings panes   Not built yet

  **"Not built yet" is the one that survives**, because it is the only one of
  the three that is certainly true. The other two are promises. So was the
  sentence under the old page: *"This section is on the roadmap and will be
  built out in the coming weeks. The menu item is in place now so navigation
  stays consistent."* That is two promises OnHand cannot keep, followed by the
  app explaining its own plumbing to the person reading it. Rule 35 says a
  stopped screen says what has happened, what it means, and what they can do,
  and never why OnHand is built the way it is.

  **The shape is the empty screen Groups F and G settled**, because an empty
  screen and an unbuilt one are the same sentence with a different cause. The
  only thing that changes between a whole page and one pane inside a settings
  screen is how much room it is given, which is what `pane` is.

  **One departure from the drawing, and it is deliberate and reported rather
  than quiet.** The approved pane shows the same generic sentence as the whole
  page. Three Site Settings panes have their own sentence today, settled by
  Group D, and each says something specific and true that the generic one does
  not: that keys are held by the server and never by the browser, what a file
  transfer would actually be, and that a submitted count builds its report,
  tries to send it, fails quietly, and is recorded anyway. Deleting three true
  sentences to match a drawing that was demonstrating a SHAPE would make the app
  worse, so `says` lets a caller keep its own and the default is the approved
  one. **The owner has been told and can overrule it**, which is the same way
  the idle warning's two hours are handled.
*/
export default function NotBuiltYet({ title, says, pane = false }) {
  return (
    <div className={'nby' + (pane ? ' pane' : '')}>
      <span className="nby-badge">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"
          stroke="var(--text-secondary)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          {/* A hammer. Not built yet. */}
          <path d="M14.5 5.5 18 9l-8.5 8.5L6 14z" /><path d="M13 4l4 4" />
          <path d="M5.5 15.5 3 18l3 3 2.5-2.5" />
        </svg>
        Not built yet
      </span>
      <div className="nby-title">{title}</div>
      <div className="nby-says">{says || 'This is on the list. Nothing here works yet.'}</div>
    </div>
  );
}
